import React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {ButtonRaw} from '@/components/Button';
import InfoPopup from '@/components/Popup/InfoPopup';
import useConfigExternalLink from '@/hooks/externalLink/useConfigExternalLink';
import deviceStateService from '@/services/device/deviceStateService';
import mwStateService from '@/services/mw/mwStateService';
import appRouterService from '@/services/route/appRouterService';
import {selectDeviceDefaultName} from '@/state/selectors/mw';
import {hideModalAction} from '@/state/slices/modalSlice';
import {formatString, formatStringWithComponents} from '@/utils/stringUtils';

import {useRegistrationErrorButtons} from './hooks/useRegistrationErrorButtons';
import {getRegistrationErrorContent} from './registrationErrorPopupService';

const DeviceRegistrationErrorPopup = ({modalType, isHolder, statusCode, messageValue, isHolderReconnect}) => {
    const dispatch = useDispatch();
    const deviceName = useSelector(selectDeviceDefaultName);

    const errorContent = getRegistrationErrorContent(statusCode, messageValue);
    const {icon, title, description, descriptionLinkButton} = errorContent;

    const {redirectToExternalLink} = useConfigExternalLink(descriptionLinkButton?.externalLink);
    const descriptionLink = descriptionLinkButton ? (
        <ButtonRaw
            className='inline'
            onClick={redirectToExternalLink}
            dangerouslySetInnerHTML={{__html: descriptionLinkButton.text}}
        />
    ) : null;

    const closeModal = () => {
        dispatch(hideModalAction(modalType));
    };

    const handleClose = () => {
        closeModal();

        if (isHolderReconnect) {
            //if user close registration popup on holder reconnect then clear holder state
            mwStateService.clearHolderState();
        } else {
            deviceStateService.clearDeviceState();
            appRouterService.forwardToDevicesPage(true);
        }
    };

    const {primaryButton, secondaryButton} = useRegistrationErrorButtons({
        errorContent,
        onClose: closeModal,
        isHolder,
        isHolderReconnect,
    });

    return (
        <InfoPopup
            className='ml:pt-20'
            onClose={handleClose}
            title={formatString(title, deviceName)}
            description={formatStringWithComponents(description, descriptionLink)}
            primaryButton={primaryButton}
            secondaryButton={secondaryButton}
            icon={icon}
            isBlockerOverlay
            overlayClassName='z-[105]'
        />
    );
};

export default DeviceRegistrationErrorPopup;
